export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[A-Z])(?=.*\W)[^ ]{6,}$/;
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const URL_REGEX = /^(http|https):\/\/[^ "]+$/;
export const COUPON_CODE = "coupon_code";
export const UTM_PARAMS_COOKIE = "utm_params";
export const COMBINED_STEPS_COOKIE_NAME = "suf_exp_cn";
